import { Fragment, h } from "preact";
import { useCallback, useState } from "preact/hooks";
import { Tabs } from "components/Tabs";
import { Coords } from "components/Panel/Coords";
import { Lines } from "components/Panel/Lines";
import { Settings } from "components/Panel/Settings";
import { Overview } from "components/Panel/Overview";
import { useLocale } from "locale";
import "./styles.css";

type TabKeys = "values" | "coords" | "settings";

export const Volume = () => {
  const { t } = useLocale();
  const [activeTab, setActiveTab] = useState<TabKeys>("values");

  const handleClickTab = useCallback((key: TabKeys) => setActiveTab(key), []);

  return (
    <Fragment>
      <Tabs<TabKeys>
        tabs={[
          { key: "values", label: t("panel.tabs.values") },
          { key: "coords", label: t("panel.tabs.coords") },
          { key: "settings", label: t("panel.tabs.settings") },
        ]}
        activeTab={activeTab}
        onClick={handleClickTab}
      />

      <div class="panel__table-container">
        {activeTab === "values" && <Lines distanceOnly={true} />}
        {activeTab === "coords" && <Coords />}
        <Settings active={activeTab === "settings"} />
      </div>

      {activeTab === "values" && <Overview />}
    </Fragment>
  );
};
